import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Referential } from '../models/referential';
import { ServiceResponse } from '../models/service-response';
import { ClassService } from '../rest_services/class.service';
import { CustomersService } from '../rest_services/customers.service';
import { TeamService } from '../rest_services/team.service';
import { VisitService } from '../rest_services/visit.service';
import { MsSectorService } from '../rest_services/ms-sector.service';
import { SettingsService } from '../rest_services/settings.service';
import { UserService } from '../rest_services/user.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit, OnDestroy {

  loading_indicator:boolean=true;
  loading_visit:boolean=true;
  customersLoading:boolean=true;
  newCustomerForm!:FormGroup;
  updateCustomerForm:FormGroup;
  refSectors:any[]=[];
  refCities:any[]=[];
  addError: string="";
  classesSubscription!: Subscription;
  classes: any;


  commercials:any[]=[];
  commercialsSubscriptions!: Subscription;
  

  loadingCustomersIndicators = true;
  custIndicatorsSubscription!: Subscription;
  custIndicators:any;

  loadingCustomersVisits = true;
  custVisitsSubscription!: Subscription;
  custVisits: Array<any> = [];
  token:any = '';

  constructor(private fb:FormBuilder,
              private customersService:CustomersService,
              private classService: ClassService,
              private settingsService:SettingsService,
              private msSector:MsSectorService,
              private userService:UserService,
              private teamService: TeamService,
              private visitService: VisitService,
              private route:ActivatedRoute,
              private router:Router) {
    this.initNewForm();
    this.updateCustomerForm = this.fb.group({
      'social': ['', Validators.required],
      'sector' : ['', Validators.required],
      'agent' : [''],
      'email' : [''],
      'city' : ['', Validators.required],
      'zip' : [''],
      'address' : [''],
      'phone' : [''],
      'skype' : [''],
      'class' : [''],
      'commercial':['']
    });
  }
  role:any=null;comp:any=null;
  allCustomers:any[]=[];
  mobile:boolean=false;medium:boolean=false;
  user: any;

  ngOnInit(): void {
    
    this.getConfig();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.getAllCustomers();
    
    // this.getCustomersIndicators();
   // this.getSectors();
    //this.getCities();
   // this.getClasses();
   // this.getIndicators();
    this.getCommercials();
    this.loading_visit=false;

    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
      this.comp=localStorage.getItem("comp");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
      this.comp=sessionStorage.getItem("comp");
    }

    $('.panel-collapse').on('show.bs.collapse', function () {
      $(this).siblings('.panel-heading').addClass('active');
    });
  
    $('.panel-collapse').on('hide.bs.collapse', function () {
      $(this).siblings('.panel-heading').removeClass('active');
    });

    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
    this.getClasses();
  }

  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  initNewForm(){
    this.newCustomerForm = this.fb.group({
      'social': ['', Validators.required],
      'sector' : ['', Validators.required],
      'agent' : [''],
      'email' : [''],
      'city' : ['', Validators.required],
      'zip' : [''],
      'address' : [''],
      'phone' : [''],
      'skype' : [''],
      'class' : [''],
      'commercial':['']
    });
  }
  
  // affectedCustomersTotal:any=0;
  totalCustomers:any = 0;
  rankCustomersByCommercial:any[]=[];
  getCustomersIndicators(){
    this.custIndicatorsSubscription = this.customersService.getCompanyCustomersIndicators().subscribe(
      ( data: ServiceResponse ) => {        
        if(data.code=="bb3fd4cd65c20ba03f42375066696314"){
          this.rankCustomersByCommercial = data.indicators.commercialsCustomers.sort((a:any, b:any) => b.customers - a.customers);
          this.totalCustomers = data.indicators.companyCustomers;
        }
        this.loadingCustomersIndicators = false;
      },
    )  
  }

  getAllCustomers(){
    this.userService.getUserInfo();
    this.userService.userSubject.subscribe(
        (data)=>{
          if(data.code =="f99fc2d2a6c1e8eb12bd88d1b0d05d26"){
            this.user = data.connected_user;
          }
        }
      );
    this.showBloc =true;
    this.customersLoading=true;
    this.customersService.getAllCustomers();
    this.customersService.customersSubject.subscribe(
      ( data: any ) => {
        this.customersLoading=false;     
        if(data.code=="a12d89f623abb138ebacc91b3703326a"){
          if(data.customers != null && data.customers != undefined){
            data.customers.forEach((customer:any) => {
            this.msSector.getSector(this.token, customer.sector).subscribe(
                (sectorLabel: any) => {
                  customer.customer_sector = sectorLabel.label;
                },
                (error) => {
                  console.log(error);
                }
              );
            });
            this.allCustomers = data.customers;
            this.InitAllCustomers = data.customers;
          }else {
            this.allCustomers = [];
            this.InitAllCustomers = [];
          }
          var url = this.router.url;
          const decodedURL = decodeURIComponent(url);
          var myurls = decodedURL.split(";cs=");
          var customerId = myurls[1];
          
          if(customerId!="all" && customerId !=""){
            this.selectCustomer(customerId);
            
            setTimeout(()=>{
              (<any>$("#ficheModal")).modal('show');
            }, 500);
          }
          setTimeout(()=>{
              (<any>$("#alter_pagination")).DataTable( {
                "destroy":true,
                "pagingType": "full_numbers",
                "scrollX": '400px',
                dom: 'Blfrtip',
                "iDisplayLength": 25,
                "scrollCollapse": true,
                order: [[4, 'desc']],
                buttons: {
                  buttons: [
                      { extend: 'copy', className: 'btn btn-default btn-rounded btn-sm mb-4', 
                      action: function () {
                        // Copy the table data to clipboard
                        var table = (<any>$("#alter_pagination")).DataTable();
                        var tableData = table.buttons.exportData().body;
                        var textData = '';
                        tableData.forEach((row:any) => {
                          textData += row.join('\t') + '\n';
                        });
                        const dummyTextarea = document.createElement('textarea');
                        dummyTextarea.textContent = textData;
                        document.body.appendChild(dummyTextarea);
                        dummyTextarea.select();
                        document.execCommand('copy');
                        document.body.removeChild(dummyTextarea);
          
                        $("#copyMessage").addClass("show");
                        setTimeout(() => {
                          $("#copyMessage").removeClass("show");
                        }, 2000);
                      }},
                      { extend: 'excel', className: 'btn btn-default btn-rounded btn-sm mb-4' },
                      { extend: 'print', className: 'btn btn-default btn-rounded btn-sm mb-4' }
                  ]
                },
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                        type: 'line',
                        width: '60',
                        height: '20',
                        lineColor: '#1a73e9',
                        fillColor: '#c2d5ff',
                        spotColor: 'transparent',
                        minSpotColor: 'transparent',
                        maxSpotColor: 'transparent',
                        highlightSpotColor: 'transparent',
                        highlightLineColor: 'transparent',
                    });
                }
            });
          }, 200);
        }
      },
    )  
  }

  getCommercials() {
    this.commercialsSubscriptions = this.teamService.getCommercials().subscribe(
      (resp: ServiceResponse) => {
        if(resp.code == "b1f37eec383fcada527079602ac178b3"){
          this.commercials = resp.commercials;
        }
      },
      (err: any) => {
        console.log(err);
        
      }
    );
  }
  selectedCustomer:any=null;
  selectCustomer(customer:any){
    this.selectedCustomer = null;
    this.selectedCustomer = this.allCustomers.find(d => d.customer== customer);
    const imageDiv = document.getElementById('imageDiv');
    if(imageDiv)imageDiv.innerHTML = '';

    if (this.selectedCustomer?.customer_logo) {
      // Convert the base64 logo to a data URL
      const logoDataUrl = 'data:image/*;base64,' + this.selectedCustomer?.customer_logo;
      if (imageDiv) {
        // Create an <img> element and set its src attribute
        const imgElement = document.createElement('img');
        imgElement.src = logoDataUrl;
        imgElement.alt = 'Customer Logo';
        imgElement.style.width = '100px';
        imgElement.style.borderRadius= "50%";
        imgElement.style.border = 'solid 5px #bad0c9';
        imageDiv.innerHTML = '';
        imageDiv.appendChild(imgElement);
      }
    }
    this.getConversationAboutCustomer(customer);
  }

  getCustomerVisits(uuid:string){
    this.loadingCustomersVisits = true;
    this.custVisitsSubscription = this.visitService.getCustomerVisits(uuid).subscribe(
      (resp: ServiceResponse) => {
        if(resp.code=="1c44d34b762db2c2d2d02fed29651042"){
          this.custVisits = resp.visits.sort((a:any, b:any) => new Date(a.visitPlannedDate).getTime() - new Date(b.visitPlannedDate).getTime());          
        }
        this.loadingCustomersVisits = false;
      },
      (err) => {
        console.log(err);
        this.loadingCustomersVisits = false;
      }
    );
  }
  selectedCustomerToUpdate:any=null;
  selectCustomerToUpdate(customer:any){
    this.selectedCustomer =null;
    this.selectedCustomerToUpdate = this.allCustomers.find(d => d.customer== customer);

    this.updateCustomerForm.patchValue({
      'social' : this.selectedCustomerToUpdate?.customer_rs,
      'sector' : this.selectedCustomerToUpdate?.sector,
      'agent' : this.selectedCustomerToUpdate?.customer_agent,
      'email' : this.selectedCustomerToUpdate?.customer_email,
      'city' : this.selectedCustomerToUpdate?.city,
      'zip' : this.selectedCustomerToUpdate?.customer_zip_code,
      'address' : this.selectedCustomerToUpdate?.customer_address,
      'phone' : this.selectedCustomerToUpdate?.customer_phone,
      'skype' : this.selectedCustomerToUpdate?.customer_skype,
      'class' : this.selectedCustomerToUpdate?.customerClass?.uuid,
      'commercial': (this.selectedCustomerToUpdate?.commercials[0]?.commercial_uuid)?this.selectedCustomerToUpdate?.commercials[0]?.commercial_uuid:''
    });
    // this.updateCustomerForm.controls['class'].setValue(this.selectedCustomerToUpdate?.customer_class);
    // this.updateCustomerForm.controls['social'].setValue(this.selectedCustomerToUpdate?.customer_rs);
    // this.updateCustomerForm.controls['sector'].setValue(this.selectedCustomerToUpdate?.sector);
    // this.updateCustomerForm.controls['city'].setValue(this.selectedCustomerToUpdate?.city);
  }
  loadingAddingCustomer:boolean=false;
  newCustomerRequest:any={};
  addNewCustomer(){
    var valuesNewCustomerForm = this.newCustomerForm.value;
    let customerClass = new Referential();
    customerClass.uuid = valuesNewCustomerForm.class;
    this.loadingAddingCustomer = true;
    if(this.newCustomerForm.valid){
      this.newCustomerRequest = {
        social_reason:valuesNewCustomerForm.social,
        customer_sector:valuesNewCustomerForm.sector,
        represented_by:valuesNewCustomerForm.agent,
        customer_email:valuesNewCustomerForm.email,
        customer_city:valuesNewCustomerForm.city,
        customer_zip:valuesNewCustomerForm.zip,
        customer_address:valuesNewCustomerForm.address,
        customer_phone: valuesNewCustomerForm.phone,
        customer_skype: valuesNewCustomerForm.skype,
        customer_refClass: customerClass,
        customerCommercial: valuesNewCustomerForm.commercial
      };
      this.customersService.newCustomerRequest = this.newCustomerRequest;
      this.customersService.newCustomer();
      this.newCustomerRequest=this.customersService.newCustomerSubject.subscribe(
        ( data: any ) => {
          if(data.code=="321b6e3b3785131f5cee153737dba9a2"){
            this.loadingAddingCustomer = false;
            this.newCustomerForm.reset();
            this.newCustomerForm.controls['sector'].setValue("", {onlySelf: true});
            this.newCustomerForm.controls['city'].setValue("", {onlySelf: true});
            this.newCustomerForm.controls['commercial'].setValue("", {onlySelf: true});

            $("#customer_added").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#customer_added").hide();
            }, 8000);
            this.allCustomers.push(data.customer);
            this.getCustomersIndicators();
          } else if (data.code=="06c61e9f990cce9353c3064f99f6ec42"){
            this.addError ="Client existe dèja"; 
            this.loadingAddingCustomer = false;
            $("#customer_not_added").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#customer_not_added").hide();
            }, 8000)
          } else {
            this.addError ="Client non ajouté"; 

            this.loadingAddingCustomer = false;
            $("#customer_not_added").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#customer_not_added").hide();
            }, 8000);
          }
        },
        (err: any) => {
          this.addError ="Client non ajouté"; 
          this.loadingAddingCustomer = false;
          $("#customer_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_added").hide();
          }, 8000);
        }
      )
    }
  }

  getCityNames(customerCities: any[]) {
    return customerCities.map((city: any) => city.name).join(" <br> ");
  }
  showBloc:boolean=false;
  hideBlocList(){
    this.showBloc =false;
  }
  selectedToDelete:any=null;
  selectToDelete(uuid:any){
    this.selectedToDelete = uuid;
  }
  loadingDeleteCustomer:boolean=false;
  deleteCustomer(){
    this.loadingDeleteCustomer = true;
    this.loadingAddingCustomer = true;
    this.customersService.deleteCustomer(this.selectedToDelete);
    this.newCustomerRequest=this.customersService.deleteCustomerSubject.subscribe(
      ( data: any ) => {
        if(data.code=="07eecf57368f24ff98b16f12028ebf14"){
          this.loadingAddingCustomer = false;
          this.newCustomerForm.reset();
          $("#customer_deleted").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_deleted").hide();
          }, 8000);
          let index = this.allCustomers.findIndex(d => d.customer === this.selectedToDelete);
          this.allCustomers.splice(index, 1);
        }else if(data.code=="6df28a63c9c310c55e25d640ae7ee7da"){
          this.loadingAddingCustomer = false;
          $("#customer_not_deleted_have_visits").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_deleted_have_visits").hide();
          }, 8000);
        }else {
          this.loadingAddingCustomer = false;
          $("#customer_not_deleted").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_deleted").hide();
          }, 8000);
        }
        window.scroll({ 
          top: 0, 
          left: 0, 
          behavior: 'smooth' 
        });
      },
    )
  }

  customerArchiveRequest:any={};
  archiveCustomer(){
    this.loadingAddingCustomer = true;
    this.customersService.archiveCustomer(this.selectedToDelete);
    this.customerArchiveRequest=this.customersService.archiveCustomerSubject.subscribe(
      ( data: any ) => {
        if(data.code=="e5b99f09c7461ee9de1537ddcfd1c638"){
          this.loadingAddingCustomer = false;
          $("#customer_archived").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#customer_archived").hide();
          }, 8000);
          let index = this.allCustomers.findIndex(d => d.customer === this.selectedToDelete);
          this.allCustomers.splice(index, 1);
        }else if(data.code=="587df0508983999872819f4041aef551"){
          this.loadingAddingCustomer = false;
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
          }, 8000);
        }else {
          this.loadingAddingCustomer = false;
          $("#customer_not_archived").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            });
            $("#customer_not_archived").hide();
          }, 8000);
        }
        window.scroll({ 
          top: 0, 
          left: 0, 
          behavior: 'smooth' 
        });
      },
    )
  }

  customersFilterSubscription!: Subscription;
  showCommercials:boolean=false;
  showClasses:boolean=false;
  typeFilter:any;
  getCustomersCritary(critary:any, event:any){
    const items = document.querySelectorAll('.btn-filter');
    this.countNotAffected =0
    if(event!=""){
      if(items.length> 0){
        event.target.classList.add('btn-filter');
        items.forEach((element, index) => {
          if (element !== event.target){
              element.classList.remove('btn-filter');
          }
        });
      }else {
        event.target.classList.add('btn-filter');
      }
    }
    if(critary=="notAffected"){
      this.showBloc =true;
      this.customersOfCommercial(critary,null);
      this.showCommercials=false;
    }else if(critary=="all"){
      this.getAllCustomers();
      this.showCommercials=false;
    }else if(critary=="notClassified"){
      this.typeFilter = "NOCLSS";
      this.showBloc =true;
      this.customersOfCommercial("", this.typeFilter);
      this.showClasses=false;
    }else if(critary=="classified"){
      this.typeFilter = "WITHCLSS";
      this.showClasses=true;
      this.customersOfCommercial("allCommercials", this.typeFilter);
    }else if(critary=="classifiedAffected"){
      this.showCommercials=true;
      this.typeFilter = "WITHCLSS";
    }else if (critary=="ofAllClasses"){
      this.typeFilter = "ofAllClasses"
      this.allCustomers = [];
      
      (<any>$("#alter_pagination")).DataTable().destroy();
      setTimeout(()=>{
        var filtredList = this.InitAllCustomers.filter(d => d.customerClass != undefined);
        this.allCustomers = filtredList;
        this.initDataTable();
      }, 800);
      this.showCommercials=false;
      this.showBloc =true;
    }else {
      this.showCommercials=true;
      this.showClasses=false;
    }
  }
  initDataTable(){
    setTimeout(()=>{
      (<any>$("#alter_pagination")).DataTable( {
        "destroy":true,
        "pagingType": "full_numbers",
        "scrollX": '400px',
        dom: 'Blfrtip',
        "iDisplayLength": 25,
        "scrollCollapse": true,
        order: [[4, 'desc']],
        buttons: {
          buttons: [
              { extend: 'copy', className: 'btn btn-default btn-rounded btn-sm mb-4', 
              action: function () {
                // Copy the table data to clipboard
                var table = (<any>$("#alter_pagination")).DataTable();
                var tableData = table.buttons.exportData().body;
                var textData = '';
                tableData.forEach((row:any) => {
                  textData += row.join('\t') + '\n';
                });
                const dummyTextarea = document.createElement('textarea');
                dummyTextarea.textContent = textData;
                document.body.appendChild(dummyTextarea);
                dummyTextarea.select();
                document.execCommand('copy');
                document.body.removeChild(dummyTextarea);
  
                $("#copyMessage").addClass("show");
                setTimeout(() => {
                  $("#copyMessage").removeClass("show");
                }, 2000);
              }},
              { extend: 'excel', className: 'btn btn-default btn-rounded btn-sm mb-4' },
              { extend: 'print', className: 'btn btn-default btn-rounded btn-sm mb-4' }
          ]
        },
        "language": {
          "sProcessing": "Traitement en cours ...",
          "sLengthMenu": "Afficher _MENU_ lignes",
          "sZeroRecords": "Aucun résultat trouvé",
          "sEmptyTable": "Aucune donnée disponible",
          "sInfo": "",
          "sInfoEmpty": "",
          searchPlaceholder: "Saisir un mot clé",
          "sInfoFiltered": "",
          "sInfoPostFix": "",
          "sSearch": "Rechercher:",
          "sUrl": "",
          "sInfoThousands": ",",
          "sLoadingRecords": "Chargement...",
          "oPaginate": {
            "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
          },
          "oAria": {
            "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
          }
        },
        drawCallback: function () {
          (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                type: 'line',
                width: '60',
                height: '20',
                lineColor: '#1a73e9',
                fillColor: '#c2d5ff',
                spotColor: 'transparent',
                minSpotColor: 'transparent',
                maxSpotColor: 'transparent',
                highlightSpotColor: 'transparent',
                highlightLineColor: 'transparent',
            });
        }
    });
  }, 200);
  }
  getClasses(){
    this.classesSubscription = this.classService.getClasses().subscribe(
      (data: ServiceResponse) => {        
        if(data.code == "7cd8d69b7048301e37f4ddaf4959218c"){
          this.classes = data.classes?data.classes:[];
        }    
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  selectedCommercialCritary:any=null;
  InitAllCustomers:any[]=[];
  countUnclassified:any;
  countNotAffected:any;
  customersOfCommercial(commercial:any,type:any){
    this.showBloc =true;
    if(type!="NOCLSS" && type!=null){
      type= type+this.selectedClassValue;
    }
    this.countNotAffected=0;
    this.selectedCommercialCritary = commercial;   
    (<any>$('#alter_pagination')).DataTable().clear().destroy();
      this.customersLoading=true;
      this.customersService.getCustomersOfCommercial(commercial,type);
      this.customersService.customersFilterSubscription.subscribe(
        ( data: any ) => {
          this.customersLoading=false; 
          data.customers.forEach((customer:any) => {
            this.msSector.getSector(this.token, customer.sector).subscribe(
              (sectorLabel: any) => {
                customer.customer_sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          });
          this.allCustomers = data.customers;
          setTimeout(()=>{
            (<any>$("#alter_pagination")).DataTable( {
              "destroy":true,
              "pagingType": "full_numbers",
              "scrollX": '400px',
              dom: 'Blfrtip',
              "iDisplayLength": 25,
              buttons: {
                buttons: [
                    { extend: 'copy', className: 'btn btn-default btn-rounded btn-sm mb-4' },
                    { extend: 'excel', className: 'btn btn-default btn-rounded btn-sm mb-4' },
                    { extend: 'print', className: 'btn btn-default btn-rounded btn-sm mb-4' }
                ]
              },
              "scrollCollapse": true,
              order: [[4, 'desc']],
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "_MAX_ Clients",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "_MAX_ Clients",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
          var oTable = (<any>$('#alter_pagination')).DataTable();
          var info = oTable.page.info();
          
          if(type!=null && type.toString().indexOf("NOCLSS")>0){
            var count = info.recordsTotal;
            this.countUnclassified = count;
          }
          if(type==null){
            var count = info.recordsTotal;
            this.countNotAffected = count;
          }
          
        }, 200);      
          if(data.code==""){
          }
        });
    setTimeout(()=>{
      this.allCustomers = this.InitAllCustomers.filter(d => d.commercials[d?.commercials.length-1]?.commercial== commercial);
        (<any>$('#alter_pagination')).DataTable().rows.add(this.allCustomers);
    }, 500);
  }
  selectedClassValue:any;
  selectedClass(classe:any){    
    $('input[name="radio"]').prop('checked', false);
    this.selectedClassValue = classe;
  }
  updateCustomerRequest:any={};
  updateCustomer(code:any){
    var valuesUpdateCustomerForm = this.updateCustomerForm.value;
    let customerClass = new Referential();
    customerClass.uuid = valuesUpdateCustomerForm.class;
    
    this.loadingAddingCustomer = true;
    if(this.updateCustomerForm.valid){
          this.updateCustomerRequest = {
            social_reason:valuesUpdateCustomerForm.social,
            customer_sector:valuesUpdateCustomerForm.sector,
            represented_by:valuesUpdateCustomerForm.agent,
            customer_email:valuesUpdateCustomerForm.email,
            customer_city:valuesUpdateCustomerForm.city,
            customer_zip:valuesUpdateCustomerForm.zip,
            customer_address:valuesUpdateCustomerForm.address,
            customer_phone: valuesUpdateCustomerForm.phone,
            customer_skype: valuesUpdateCustomerForm.skype,
            customer_refClass: customerClass,
            customerCommercial: valuesUpdateCustomerForm.commercial
          };
    
    
      this.customersService.updateCustomerRequest = this.updateCustomerRequest;
      this.customersService.updateCustomer(code);
      this.updateCustomerRequest=this.customersService.updateCustomerSubject.subscribe(
        ( data: any ) => {
          if(data.code=="321b6e3b3785131f5cee153737dba9a2"){
            this.loadingAddingCustomer = false;
            this.updateCustomerForm.reset();
            this.updateCustomerForm.controls['sector'].setValue("", {onlySelf: true});
            this.updateCustomerForm.controls['city'].setValue("", {onlySelf: true});
            this.updateCustomerForm.controls['class'].setValue("", {onlySelf: true});
            this.updateCustomerForm.controls['commercial'].setValue("", {onlySelf: true});


            $("#customer_updated").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#customer_updated").hide();
            }, 8000);

            let customerUpdated = data.customer;

            let oldCustomer = this.allCustomers.find(el=>el.customer==code);
            if(oldCustomer.added_by)
            customerUpdated.added_by = oldCustomer.added_by;
            customerUpdated.customer = code;
            if(oldCustomer.customer_added_at)
            customerUpdated.customer_added_at = oldCustomer.customer_added_at;
            let customerIndex = this.allCustomers.findIndex(el=>el.customer==code);
            (<any>$("#alter_pagination")).DataTable().destroy();
            this.allCustomers.splice(customerIndex,1,customerUpdated);    

            setTimeout(()=>{
              (<any>$("#alter_pagination")).DataTable( {
                "destroy":true,
                "pagingType": "full_numbers",
                "scrollX": '400px',
                "iDisplayLength": 25,
                "scrollCollapse": true,
                order: [[4, 'desc']],
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                        type: 'line',
                        width: '60',
                        height: '20',
                        lineColor: '#1a73e9',
                        fillColor: '#c2d5ff',
                        spotColor: 'transparent',
                        minSpotColor: 'transparent',
                        maxSpotColor: 'transparent',
                        highlightSpotColor: 'transparent',
                        highlightLineColor: 'transparent',
                    });
                }
            });
          }, 200);

          }else {
            this.loadingAddingCustomer = false;
            $("#customer_not_updated").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#customer_not_updated").hide();
            }, 8000);
          }
        },
      )
    }
  }

  indicators:any;
  no_indicators:boolean=false;

  getIndicators(){
    this.customersService.getIndicatorsCustomers();
    this.customersService.indicatorsSubject.subscribe(
      ( data: any ) => {        
        if(data.code=="122da9e5fbdd3f20770a41fd9a7c19cc"){
          this.indicators = data.indicators;          
          this.no_indicators = false;
        }else {
          this.no_indicators = true;
        }
        this.loading_indicator=false;
      },
    )  
  }

  loadingMessages:boolean=false;
  messages:any[]=[];

  getConversationAboutCustomer(customerUuid:string){
    this.messages = [];
    this.loadingMessages=true;
    this.customersService.getCustomerConversation(customerUuid).subscribe(
      ( data: any ) => {
        if(data.code=="a06f376e86f9c47135aee1d1bac7b3e3") {
          this.messages = data.messagesVisit;
          $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
        }
        this.loadingMessages=false;
      },
      error => {
        console.error('There was an error!', error);
      }
    )
  }
  sending: boolean = false;
  sendNewMessage(customerUuid:string){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.customersService.sendMessage(customerUuid, requestBody).subscribe(
        ( data: any ) => {
          if(data.code=="2ea8e5510c04f55b90c85304f9f59532") {
            $('#messageText').val("");
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0].scrollHeight }, 500)
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0].scrollHeight }, 200)
          }
          this.loadingMessages=false;
          this.sending = false;
        },
        error => {
          console.error('There was an error!', error);
        }
      );
    }
    
  }

  ngOnDestroy() {
    this.classesSubscription?.unsubscribe();
    this.commercialsSubscriptions?.unsubscribe();
    this.custVisitsSubscription?.unsubscribe();
  }

  getArchivedCustomers(critary:any, event:any){
    this.allCustomers = [];
    const items = document.querySelectorAll('.btn-filter');
    if(event!=""){
      if(items.length> 0){
        event.target.classList.add('btn-filter');
        items.forEach((element, index) => {
          if (element !== event.target){
              element.classList.remove('btn-filter');
          }
        });
      }else {
        event.target.classList.add('btn-filter');
      }
    }
    (<any>$('#alter_pagination')).DataTable().clear().destroy();
      this.customersLoading=true;
      this.customersService.getArchivedCustomers(critary);
      this.customersService.archivedCustomersFilterSubscription.subscribe(
        ( data: any ) => {
          this.customersLoading=false; 
          data.customers.forEach((customer:any) => {
            this.msSector.getSector(this.token, customer.sector).subscribe(
              (sectorLabel: any) => {
                customer.customer_sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          });
          this.allCustomers = data.customers;
          setTimeout(()=>{
            (<any>$("#alter_pagination")).DataTable( {
              "destroy":true,
              "pagingType": "full_numbers",
              "scrollX": '400px',
              dom: 'Blfrtip',
              "iDisplayLength": 25,
              buttons: {
                buttons: [
                    { extend: 'copy', className: 'btn btn-default btn-rounded btn-sm mb-4' },
                    { extend: 'excel', className: 'btn btn-default btn-rounded btn-sm mb-4' },
                    { extend: 'print', className: 'btn btn-default btn-rounded btn-sm mb-4' }
                ]
              },
              "scrollCollapse": true,
              order: [[4, 'desc']],
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "_MAX_ Clients",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "_MAX_ Clients",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);   
        });
    // setTimeout(()=>{
    //   this.allCustomers = this.InitAllCustomers.filter(d => d.commercials[d?.commercials.length-1]?.commercial== commercial);
    //     (<any>$('#alter_pagination')).DataTable().rows.add(this.allCustomers);
    // }, 500);
      (<any>$("#alter_pagination")).DataTable().destroy();
      setTimeout(()=>{
        this.initDataTable();
      }, 800);
      this.showCommercials=false;
      this.showBloc =true;
  }
}
